/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByUserActionKind = (typeof GroupByUserActionKind)[keyof typeof GroupByUserActionKind];

export const GroupByUserActionKind = {
  user_action: 'user_action',
} as const;
